<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 px-2 text-center">
      <h2 class="mb-2 text-center">Request Verification Code</h2>
      Choose a device to get a password recovery code.
    </div>
    <v-form ref="form" @submit.prevent="chooseMethod">
      <div class="d-flex flex-column align-center">
        <v-radio-group v-model="method_id">
          <v-radio 
            v-for="method in recoveryMethods"
            :key="method.method_id"
            :value="method.method_id"
          >
            <template #label>
              <div class="d-flex align-center">
                <v-icon v-if="method.type == 0" color="grey" class="mr-1">
                  mdi-email-outline
                </v-icon>
                <v-icon v-else color="grey" class="mr-1">
                  mdi-cellphone-message
                </v-icon>
                {{ method.label }}
              </div>
            </template>
          </v-radio>
        </v-radio-group>

        <v-btn width="60%" type="submit" color="primary">Send Code</v-btn>
      </div>


    </v-form>

    <div class="ml-3 mt-3 text-center">
      <a style="text-decoration: underline;" @click="$router.back()">Back to Login</a>
    </div>

    <ErrorOverlay
      title="Password Reset Error" 
      v-model="error_dialog"
      :loading="loading"
      @done="$router.replace({ name: 'recover' })"
    >
      No user found with that email...
    </ErrorOverlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from '@/lib/validations'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'RecoverMethodsView',

  mixins: [ ErrorOverlayMixin ],

  data() {
    return {
      method_id: '',

      // validations
      required,
    }
  },

  computed: {
    ...mapGetters('auth', ['recoveryMethods', 'unverifiedUser']),
  },

  methods: {
    ...mapActions('auth', ['loadRecoveryMethods', 'recoverByMethod']),

    async chooseMethod() {
      if (this.$refs.form.validate()) {

        const method =  this.recoveryMethods.find( m => m.method_id == this.method_id )
        
        this.recoverByMethod(method)
        this.$router.replace({ name: 'recover/verify' })
      }
    },
  },

  async created() {
    this.loading = true
    const result = await this.loadRecoveryMethods({ id: this.unverifiedUser })
    this.loading = false

    if (result.ok) {
      this.method_id = result.methods[0].method_id
    } else {
      this.error_dialog = true
      this.error_message = result.error
    }
  },
}
</script>
